<template>
  <dl class="typebar dl-horizontal" :class="{closed:open}">
    <dt class="pull-right" @click="toggle" v-show="loanTypeArr && loanTypeArr.length !== 0">
      <a class="see__all" href="javascript:;">{{open ? '展开全部' : '收起'}}</a>
    </dt>
    <dd class="typebar-list">
      <a href="javascript:;" v-for="(item, index) in loanTypeArr" :key="index" :class="{active:index === selectedIndex}"
         @click="onClick(index, item)">{{item.name}}</a>
    </dd>
  </dl>
</template>

<script>
  export default {
    props: {
      selectedIndex: {
        type: Number
      },
      onItemClick: Function,
      loanTypeArr: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        list: [],
        open: true
      }
    },
    watch: {
      loanTypeArr () {
        if (this.loanTypeArr.length === 0) {
          return
        }
      }
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      onClick (index, item) {
        this.$emit('on-item-click', index, item)
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
  .typebar
    width 1180px
    height auto
    overflow hidden
    transition all .7s ease-in-out
    margin-top 20px
    margin-bottom 17px
    padding 0 20px
    background-color rgba(234, 234, 234, 0.3)
    dt.pull-right
      width 70px
      font-size 32px
      font-weight normal
      > a
        color #1a4369
        display block
        font-size 14px
        height 48px
        line-height 48px
        text-align center
        text-decoration none
        &:hover
          color #2b9efc
    &.closed
      height 48px
    .typebar-list
      margin-left 0
      margin-right 70px
      font-size 0
      a
        position relative
        display inline-block
        margin 8px 26px 8px 0
        padding 8px 10px 8px 24px
        font-size 16px
        color #333
        line-height 1
        letter-spacing 4px
        // background-color #fff
        // box-shadow 0 4px 24px 0 rgba(195,225,237,1)
        &:active, &:hover, &:focus, &.active
          color #2B9EFC !important
          color rgb(82, 210, 255)
          text-decoration none
        &.active
          font-weight bold
        &:before
          content ''
          position absolute
          left 8px
          top 12px
          width 7px
          height 7px
          border-radius 50%
          background-color #2b9efc

</style>



// WEBPACK FOOTER //
// typebar.vue?72689d70